/**
 * authProvider.web.ts
 *
 * Single toggle layer for the web bundle that reads AUTH_PROVIDER from the
 * webpack-injected environment and delegates every auth operation to either
 * the Entra (Azure CIAM) service or the TTAuth (GCIP) service.
 *
 * Switching providers: set AUTH_PROVIDER=entra  or  AUTH_PROVIDER=ttauth
 * in .env.web and rebuild.  No consumer code changes needed.
 *
 * Exported interface is identical to azureCiamService.web.ts:
 *   signinWithBrowser, refreshAccessToken, signoutWithBrowser, userManager
 */

// ── Entra (frozen — do not modify) ─────────────────────────────────────────
import * as entra from './azureCiamService.web';

// ── TTAuth adapter (wraps ttAuthService.web.ts) ──────────────────────────
import * as ttauth from './ttAuthAdapter.web';

// web/mocks/react-native-config.web.js exposes this as a plain object injected
// via webpack DefinePlugin / alias.  On web we read from that object.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const _rnConfigMod = require('react-native-config');
// react-native-config.web.js uses `export default` (ES module), so webpack
// wraps it as { default: { ... } }.  We must unwrap .default when present.
const RNConfig = (_rnConfigMod.default ?? _rnConfigMod) as Record<string, string>;
const USE_TTAUTH = RNConfig.AUTH_PROVIDER === 'ttauth';

export const signinWithBrowser  = USE_TTAUTH ? ttauth.signinWithBrowser  : entra.signinWithBrowser;
export const refreshAccessToken = USE_TTAUTH ? ttauth.refreshAccessToken : entra.refreshAccessToken;
export const signoutWithBrowser = USE_TTAUTH ? ttauth.signoutWithBrowser : entra.signoutWithBrowser;
export const userManager        = USE_TTAUTH ? ttauth.userManager        : entra.userManager;